import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from 'src/helpers/api/apiCore';

// api
import {
    creatEmployee as createEmployeeApi,
    updateEmployee as updateEmployeeApi,
    getAllEmployee as getAllEmployeeApi,
    getEmployee as getEmployeeApi,
} from './api';

// actions
import { employeeApiResponseSuccess, employeeApiResponseError } from './actions';

// constants
import { EmployeeActionTypes } from './constants';

type EmployeeData = {
    payload: any;
    type: string;
};

const api = new APICore();

/**
 * Add Employee
 * @param {*} payload
 */
function* AddEmployee({ payload, type }: EmployeeData): SagaIterator {
    try {
        const response = yield call(createEmployeeApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                employeeApiResponseSuccess(
                    EmployeeActionTypes.ADD_EMPLOYEE,
                    data,
                    'Employee has been created.',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while creating Employee!`;
            if (message) msg = message;
            yield put(employeeApiResponseSuccess(EmployeeActionTypes.ADD_EMPLOYEE, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(employeeApiResponseError(EmployeeActionTypes.ADD_EMPLOYEE, [], error, 404, true, false));
    }
}

/**
 * Edit Employee
 * @param {*} payload
 */
function* EditEmployee({ payload, type }: EmployeeData): SagaIterator {
    try {
        const response = yield call(updateEmployeeApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(
                employeeApiResponseSuccess(
                    EmployeeActionTypes.EDIT_EMPLOYEE,
                    data,
                    'Employee Get Updated Successfully',
                    code,
                    false,
                    true
                )
            );
        } else {
            let msg = `An error while edit Employee!`;
            if (message) msg = message;
            yield put(employeeApiResponseSuccess(EmployeeActionTypes.EDIT_EMPLOYEE, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(employeeApiResponseError(EmployeeActionTypes.EDIT_EMPLOYEE, [], error, 404, true, false));
    }
}

/**
 * Fetch Employee
 * @param {*} payload
 */
function* GetEmployee({ payload, type }: EmployeeData): SagaIterator {
    try {
        const response = yield call(getEmployeeApi, payload);
        const { data, message, success, code } = response.data;
        if (code === 200 && success) {
            yield put(employeeApiResponseSuccess(EmployeeActionTypes.GET_EMPLOYEE, data, message, code, false, false));
        } else {
            let msg = `An error while getting Employee!`;
            if (message) msg = message;
            yield put(employeeApiResponseSuccess(EmployeeActionTypes.GET_EMPLOYEE, data, msg, code, true, false));
        }
    } catch (error: any) {
        yield put(employeeApiResponseError(EmployeeActionTypes.GET_EMPLOYEE, [], error, 404, true, false));
    }
}

/**
 * Fetch Employees
 * @param {*} payload
 */
function* GetEmployees({ payload, type }: EmployeeData): SagaIterator {
    try {
        const response = yield call(getAllEmployeeApi, payload);
        const { data, message, success, code } = response.data;

        const responseData = typeof data === 'object' && Object.keys(data).length === 0 ? [] : data;
        if (code === 200 && success) {
            yield put(
                employeeApiResponseSuccess(EmployeeActionTypes.GET_EMPLOYEES, responseData, message, code, false, false)
            );
        } else {
            let msg = `An error while getting Employee Listing!`;
            if (message) msg = message;
            yield put(
                employeeApiResponseSuccess(EmployeeActionTypes.GET_EMPLOYEES, responseData, msg, code, true, false)
            );
        }
    } catch (error: any) {
        yield put(employeeApiResponseError(EmployeeActionTypes.GET_EMPLOYEES, [], error, 404, true, false));
    }
}

export function* watchGetEmployee() {
    yield takeEvery(EmployeeActionTypes.GET_EMPLOYEE, GetEmployee);
}

export function* watchGetEmployees() {
    yield takeEvery(EmployeeActionTypes.GET_EMPLOYEES, GetEmployees);
}

export function* watchAddEmployee() {
    yield takeEvery(EmployeeActionTypes.ADD_EMPLOYEE, AddEmployee);
}

export function* watchEditEmployee(): any {
    yield takeEvery(EmployeeActionTypes.EDIT_EMPLOYEE, EditEmployee);
}

function* employeeSaga() {
    yield all([fork(watchGetEmployee), fork(watchAddEmployee), fork(watchEditEmployee), fork(watchGetEmployees)]);
}

export default employeeSaga;
